import React, { useEffect, useState } from "react";
import { Breadcrumb, BreadcrumbItem, Carousel } from "flowbite-react";
import { Link, Navigate, useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import Swal from "sweetalert2";
import "../elearningHub/ElearningHub.css";
import { RiGraduationCapFill } from "react-icons/ri";
import { IMAGE_BASE_URL } from "../../config";

import "moment/locale/es";
import { GetCoursesServices } from "../../services/getCourses/GetCoursesServices";
import { GetCoursesUserServices } from "../../services/getCoursesUser/GetCoursesUserServices";
import SetCoursesUserServices from "../../services/setCoursesUser/SetCoursesUserServices";
import logsUserService from "../../services/LogsUserActionService";

const ElearningHub = () => {
  const [dataCourses, setDataCourses] = useState(null);
  const [courseUser, setCourseUser] = useState(null);
  const [errorData, setErrorData] = useState([]);
  const [errorCourseUser, setErrorCourseUser] = useState([]);
  const { token, idUser } = useAuth();
  const [isRegisterCourse, setIsRegisterCourse] = useState(null);
  const navigate = useNavigate();
  const source = sessionStorage.getItem("source");

  const handleCourseClick = (course) => {
    console.log(course);
    console.log('Entra al handleCourseClick');
    console.log('course.url_front', course.url_front)
      // navigate(`/cursos${course.url_front}`, { state: { course } });
    window.location.href = `/cursos${course.url_front}`
  };

  useEffect(() => {
    const getCourses = async () => {
      try {
        const getCourses = await GetCoursesServices(token);

        if (getCourses.errors === true) {
          setErrorData(getCourses.message);
          setDataCourses(null);
        } else {

          let courses = getCourses.data;

          // Si source es "POEP", filtrar solo el curso con ID 3
          if (source === "POEP") {
            courses = courses.filter(course => course.id === 3);
          } else {
            courses = courses.filter(course => course.id !== 3);
          }


          setErrorData(null);
          setDataCourses(courses);
        }
      } catch (error) {
        const message = error?.message;
        setErrorData(message);
        setDataCourses(null);
      }
    };

    getCourses();

    const getCourseUser = async () => {
      try {
        const getCourseUser = await GetCoursesUserServices(token, idUser);

        if (getCourseUser.errors === true) {
          setErrorCourseUser(getCourseUser.message);
          setCourseUser(null);
        } else {
          setErrorCourseUser(null);
          setCourseUser(getCourseUser.data);
        }
      } catch (error) {
        const message = error?.message;
        setErrorCourseUser(message);
        setCourseUser(null);
      }
    };

    getCourseUser();
  }, [token, idUser]);



  const registerCourse = async (courseId, idUser, courseUrl, course) => {
    console.log('courseId', courseId);
    console.log('idUser', idUser);

    try {
      // Asegúrate de que los valores de eventId y idUser sean correctos
      if (!courseId || !idUser) {
        throw new Error("Event ID or User ID is missing");
      }

      GetCoursesUserServices(token, idUser)
        .then((coursesUserResults) => {
          console.log("GetCoursesUserServices results:", coursesUserResults);

          console.log()

          if (coursesUserResults?.data.course_id == courseId) {
            console.log('El usuario ya registro este curso')
          } else {
            SetCoursesUserServices(token, idUser, courseId)
              .then((response) => {
                // Ahora verificamos el status dentro de la promesa de SetCoursesUserServices

                if (
                  response &&
                  typeof response.data === "object" &&
                  response.data !== null
                ) {
                  console.log("Respuesta válida, continuando con el proceso.");
                  console.log(response.data);
                  console.log("Curso registrado con éxito");

                  const icon = "/images/icons/Campana.png";

                  Swal.fire({
                    html: ` <div class="custom-icon-image">
                      <img class="ico-check-popup" src="${icon}" alt="?#">
                    </div>
                  <div class="text-center mt-3 text-principal-swal ApisRegular" style="
                       margin-bottom: -10px;
                       overflow: hidden!important;
                       font-size: 25px;
                       color: #4E2485 !important; 
                       margin-top: 1rem
                  ">
                    Para descargar el certificado, es necesario
                    <span class="ApisBold">completar el 100% de las actividades y módulos requeridos.</span>
                    <span class="ApisRegular text-purple" ></span><br><br>
                  </div>
                  <div>
                    <span class="ApisRegular text-purple">
                      Asegúrese de cumplir con los requisitos establecidos antes de solicitar su certificado.
                    </span><br><br>
                  </div>
                  <span classname="text-welcome-swal ApisBold" style="
                       color: #0dc5b2 !important;
                       font-size: 30px;
                  ">¡Bienvenido!</span>`,
                    showCloseButton: false,
                    width: "600px",
                    showConfirmButton: true,
                    confirmButtonText: "Aceptar",
                    customClass: {
                      title:
                        "text-principal-swal ApisRegular text-dark-purple-800",
                      htmlContainer:
                        "text-welcome-swal ApisRegular text-center text-dark-purple-800 text-event-swal",
                      popup: "swal-styles",
                    },
                  }).then((result) => {
                    if (result.isConfirmed) {
                      handleCourseClick(course);
                    }
                  });
                } else {
                  console.log("Error al registrar el curso", response.status);
                }
              })
              .catch((error) => {
                // console.log("Error al registrar el curso", error);
              });
          }


        })
        .catch((error) => {
          // Manejo de errores de la llamada a GetCoursesUserServices
          console.error("Error en GetCoursesUserServices:", error);
        });
    } catch (error) {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        title: error.message,
        customClass: {
          title: "text-center",
        },
        showConfirmButton: true,
        timer: 2500,
        timerProgressBar: true,
      });
      console.error("Error in try-catch block:", error);
    }
  };

  return (
    <>
      <div className="breadcrumb-section mb-3">
        <Breadcrumb aria-label="Default breadcrumb example container main-section p-0">
          <ol className="flex items-center container main-section p-0">
            <BreadcrumbItem
              className="flex items-center text-md font-bold text-white hover:text-white dark:text-white dark:hover:text-white"
              href="#"
            >
              <Link
                to="/e-learning-hub"
                className={`nav-link text-white ApisBold fs-5 text-decoration-none text-items-nav`}
                style={{ color: "inherit" }}
                onClick={() => logsUserService(idUser, "Clic en E-learning Hub", token)}
              >
                E-learning Hub
              </Link>
            </BreadcrumbItem>
          </ol>
        </Breadcrumb>
      </div>

      {/* card principal */}
      <div className="container flex flex-col">
        <div className="relative">
          <div
            key=""
            className="col-12 col-md-11 col-lg-12 background-e-learning top-0 p-0 pt-3 px-3"
          >
            <p className="ApisRegular text-xs p-2 m-0 text-justify text-purple">
              En estos cursos obtendrá un conocimiento general sobre la
              obesidad, explorando sus causas y efectos, las mejores prácticas
              en nutrición y ejercicio, y el impacto psicológico y social que
              genera. Cada curso le proporcionará herramientas fundamentales
              para comprender y abordar esta condición desde diversas
              perspectivas.
            </p>

            <div className="flex flex-col lg:flex-row gap-2 ml-0 lg:ml-5 four-background-taxonomy pb-12">
              <div className="w-full mt-2 lg:mt-0 flex flex-col items-start justify-start">
                <div className="flex items-start text-custom-purple-500"></div>

                <div className="max-w-1xl w-full mt-5 p-6 text-center">
                  <div className="flex flex-col lg:flex-row gap-5 justify-center items-center relative">
                    {dataCourses && (
                      <>
                        {dataCourses.map((course) => {
                          const words = course.title.split(" ");

                          const firstPart = words[0];
                          const secondPart = words.slice(1).join(" ");

                          return (
                            <div
                              className="w-[17rem] rounded-lg shadow-sm dark:bg-gray-800 dark:border-gray-700 gradient-card"
                              style={{
                                backgroundImage: `url(${IMAGE_BASE_URL + course.image_cover})`,
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                              }}
                              key={course.id}
                            >
                              <div className="container-absolute-icon">
                                <RiGraduationCapFill
                                  className={`mr-1 inline ico object-cover m-0 mt-1 icon-card-course`}
                                />
                              </div>
                              <Link
                                // to={"/cursos" + course.url_front}
                                className={`text-start block w-full`}
                                onClick={() => {
                                  console.log(course);

                                  if (courseUser.length == 0) {
                                    registerCourse(course.id, idUser, course.courseUrl, course);
                                    logsUserService(idUser, `Clic en el curso: ${course?.title}`, token);
                                  } else {
                                    courseUser.forEach((item) => {
                                      if (item.course_id === course.id) {
                                        console.log(item.course_id);
                                        logsUserService(idUser, `Clic en el curso: ${course?.title}`, token);
                                        handleCourseClick(course)
                                      } else {
                                        registerCourse(course.id, idUser, course.courseUrl, course);
                                        logsUserService(idUser, `Clic en el curso: ${course?.title}`, token);
                                      }
                                    });
                                  }

                                }}
                              >
                                <div className="h-[24rem] pb-3 px-4 flex flex-col items-start justify-end relative z-10">
                                  <p className="mb-2 text-lg ApisBold text-white break-words">
                                    {firstPart} <br /> {secondPart}
                                  </p>
                                  <div className="inline-flex items-center px-3 py-2 text-sm font-medium text-center text-white bg-custom-btn-register rounded-lg focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                                    <div>
                                      <span className="ApisBold">Ingresar</span>{" "}
                                      al curso
                                    </div>
                                    <div>
                                      <img
                                        className="mx-1"
                                        src="../images/icons/Icono Hand.png"
                                        style={{ width: "20px" }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </Link>
                            </div>
                          );
                        })}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ElearningHub;
